import { Component } from '@angular/core';

@Component({
  selector: 'app-waitingSpinner',
  templateUrl: './waitingSpinner.component.html',
  styleUrls: ['./waitingSpinner.component.scss'],
})
export class WaitingSpinnerComponent {
  public products = [1, 2, 3, 4, 5, 6, 7];
}
